import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from "react-router"
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import DeleteModal from 'pages/parts/DeleteModal'
import { returnSign, findKeyFromArrayByValue } from "helpers/helpers";
import { httpOk, GET, POST, PUT, DELETE, PATCH } from 'helpers/api'
import HintIcon from 'pages/parts/HintIcon'

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ "id": 1, "name": t('success') },
		{ "id": -1, "name": t('deleted') },
	]
	const [data, setData] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'type': 1 })
	const [modalDelete, setModalDelete] = useState(false)
	const [modalRestore, setModalRestore] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [poses, setPoses] = useState([])
	const [menuPosIds, setMenuPosIds] = useState([])
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'status': 1,
		'search': '',
	})
	const [pagination, setPagination] = useState({
		url: '/external-groups',
		response: null
	})

	async function searchWithFilter(nextFilterData = null) {
		var filterUrl = "/external-groups"
		var urlParams = ""
		const currentFilterData = nextFilterData || filterData

		if (currentFilterData.status !== null && currentFilterData.status !== undefined && currentFilterData.status !== '')
			urlParams += returnSign(urlParams) + 'status=' + currentFilterData.status
		if (currentFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + currentFilterData.pos_id
		if (currentFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + currentFilterData.search
		if (currentFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + currentFilterData.page

		const hasActiveFilter =
			(currentFilterData.status !== null && currentFilterData.status !== undefined && Number(currentFilterData.status) !== 1)
			|| !!currentFilterData.search
		setFilterDataExist(hasActiveFilter)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	function handleSearchChange(search) {
		const nextFilterData = { ...filterData, search, page: null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/external-groups', selectedItem, { loader: true })
		} else {
			response = await POST('/external-groups', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			// Точки, отмеченные в карточке меню, — это те же строки расписания,
			// что и «Меню по умолчанию» в карточке точки: одна таблица, два входа.
			if (selectedItem.id) {
				await PUT('/menu-schedules/menu', {
					external_menu_id: selectedItem.id,
					pos_ids: menuPosIds,
				}, { notification: false })
			}

			searchWithFilter()
			setShowModal(false)
		}
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	// Точки, на которых это меню стоит по умолчанию
	async function getMenuPoses(externalMenuId) {
		setMenuPosIds([])
		if (!externalMenuId) return

		const response = await GET('/menu-schedules', { external_menu_id: externalMenuId })
		if (httpOk(response)) {
			setMenuPosIds((response.data?.data ?? [])
				.filter(item => !item.price_period_id)
				.map(item => Number(item.pos_id)))
		}
	}

	function togglePos(posId) {
		setMenuPosIds(prev => prev.includes(posId)
			? prev.filter(item => item !== posId)
			: [...prev, posId])
	}

	function resetFilter() {
		const nextFilterData = {
			status: 1,
			search: '',
			page: null,
		}
		setFilterData(nextFilterData)
		setFilterDataExist(false)
		searchWithFilter(nextFilterData)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function toggleModal(bool = false, item = { 'type': 1 }) {
		setSelectedItem(item)
		setShowModal(bool)
		if (bool) getMenuPoses(item.id)
	}

	async function deleteItem() {
		const response = await DELETE(`/external-groups/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	async function restoreItem(e) {
		e.preventDefault()
		const response = await PATCH(`/external-groups/${selectedItem.id}/restore`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalRestore(false)
			setSelectedItem({ 'type': 1 })
		}
	}

	useEffect(() => {
		searchWithFilter()
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('external_menu')} [{data.total}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={handleSearchChange}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '80%' }}>{t('description')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td>
											<Link className="text-primary cursor table-first-column-clickable"
												to={`/external-menu/${item.id}`}>
												{item.name}
											</Link>
										</td>
										<td>{item.description}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{Number(item.status) > 0 &&
															<>
																<div className="table-dropdown-item"
																	onClick={() => toggleModal(true, item)}>
																	<i className="uil-edit-alt"></i>
																	{t('edit')}
																</div>
																<div className="table-dropdown-item text-danger"
																	onClick={() => {
																		setDeleteModalParams({ id: item.id, index: index });
																		setModalDelete(true)
																	}}>
																	<i className="uil-times"></i>
																	{t('delete')}
																</div>
															</>
														}
														{Number(item.status) === -1 &&
															<div className="table-dropdown-item text-success"
																onClick={() => {
																	setSelectedItem(item)
																	setModalRestore(true)
																}}>
																<i className="uil-redo"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ""}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('description')}</label>
							<input type="text" className="form-control" name="description"
								value={selectedItem.description ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'description': e.target.value })} />
						</div>
						{!!selectedItem.id && poses.length > 0 &&
							<div className="form-group">
								<label>{t('menu_poses')}<HintIcon text={t('menu_poses_hint')} /></label>
								<div className="border rounded p-2" style={{ maxHeight: '220px', overflowY: 'auto' }}>
									{poses.map((pos) => (
										<div className="form-check" key={pos.id}>
											<input type="checkbox"
												className="form-check-input"
												id={`menu-pos-${pos.id}`}
												checked={menuPosIds.includes(Number(pos.id))}
												onChange={() => togglePos(Number(pos.id))} />
											<label className="form-check-label" htmlFor={`menu-pos-${pos.id}`}>
												{pos.name}
											</label>
										</div>
									))}
								</div>
							</div>
						}
						{!selectedItem.id &&
							<div className="d-flex">
								<div className="form-check">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'type': 1 })}
										style={{ 'backgroundColor': selectedItem.type === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'type': 1 })}>
										Создать вручную
									</span>
								</div>
								<div className="form-check">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'type': 2 })}
										style={{ 'backgroundColor': selectedItem.type === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'type': 2 })}>
										Сгенерировать меню
									</span>
								</div>
							</div>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<Modal show={modalRestore} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalRestore(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('restore')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={restoreItem} autoComplete="off">
						<p className="mb-3">
							{t('are_you_sure_you_want')} <b>{t('restore')}</b>
							{selectedItem?.name ? `: ${selectedItem.name}` : ''}?
						</p>
						<div className="d-flex gap-2 w-100">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalRestore(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('restore')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index